import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

var SimpleLightbox = require('simple-lightbox');
import 'simple-lightbox/dist/simpleLightbox.css';

export function textItemsTextSliderScripts() {
  document.addEventListener('DOMContentLoaded', function () {
    const blocks = document.querySelectorAll('.textItemsText__slider');
    
    blocks.forEach(block => {
      new Splide(block, {
        type: "loop",
        perPage: 1,
        autoHeight: true,
        perMove: 1,
        arrows: false
      }).mount();
    })
  })
}
